module.exports = __webpack_public_path__ + "static/media/product-5.52ee0c92.jpg";